import { FC } from "react";
import { Container } from "./styles";

interface IEmptyFollowers {
  text: string;
}

const EmptyFollowers: FC<IEmptyFollowers> = ({ text }) => {
  return (
    <Container>
      <div className="emptyAvatarContainer">
        <span className="emptyAvatar" />
        <span className="emptyAvatar" />
        <span className="emptyAvatar" />
      </div>
      <span className="emptyText">{text}</span>
    </Container>
  )
}

export default EmptyFollowers;
